import { Lang } from "../context/LanguageContext";
import { Product, productsByLang } from "./product";
import { productIntl } from "./productIntl";

export type PaymentType = "internal" | "external";

export interface CatalogCourse {
  id: string;
  thumbnail: string;
  paymentType: PaymentType;
  externalPaymentUrl?: string;
  getProduct: (lang: Lang) => Product;
}

export const catalog: CatalogCourse[] = [
  {
    id: "clinical-veterinary-dentistry",
    thumbnail: "/gnf.jpeg",
    paymentType: "internal",
    getProduct: (lang) => productsByLang[lang],
  },
  {
    id: "clinical-veterinary-dentistry-intl",
    thumbnail: "/egitim2.jpeg",
    paymentType: "external",
    externalPaymentUrl: "https://buy.stripe.com/5kQ5kC4IfeCK4pEdZ22Nq02",
    // Always English content, regardless of the site language.
    getProduct: () => productIntl,
  },
];

export function getCourseById(id: string): CatalogCourse | undefined {
  return catalog.find((c) => c.id === id);
}
